import { Component, OnInit, OnDestroy } from '@angular/core'
import { Store, Action } from "@ngrx/store"
import { Router } from "@angular/router"
import { AppState } from "@store/app-state"
import { Enrolment } from "@models/enrolment"
import { MatrixClass } from "@models/matrix-class"
import { Contact } from "@models/contact"
import { Observable } from "rxjs/Observable"
import { ModalService } from "@services/modal"
import { EnrolmentEffects } from "@reducers/effects/enrolment"
import { EnrolmentsStore } from "@store/enrolment"
import {
  FETCH_ENROLMENT_SELECTED_CLASS,
  FETCH_ENROLMENT_SELECTED_CONTACT,
  CREATE_ENROLMENT,
  ADD_ENROLMENT
} from "@reducers/enrolments"
import {
  NUMBER_OF_CLASSES_PER_TERM,
  NUMBER_OF_ENROLMENTS_PER_CLASS_PER_CAMPUS
} from "@constants/matrix_classes"
import { Subscription } from "rxjs/Subscription";
import { Utilities } from "@helpers/utilities";

@Component({
  selector: 'enrolment-form',
  templateUrl: './enrolment-form.pug',
})
export class EnrolmentFormComponent implements OnInit, OnDestroy {

  private enrolmentsSubscription: Subscription

  public enrolment: Enrolment
  public selectedClass: MatrixClass
  public selectedContact: Contact
  public startDateInputString: string
  public transactionDateInputString: string
  public numOfClassesArray: number[] = []
  public maxPerCampus: number = NUMBER_OF_ENROLMENTS_PER_CLASS_PER_CAMPUS


  constructor(
    private router: Router,
    private store: Store<AppState>,
    private modalService: ModalService,
    private enrolmentEffects: EnrolmentEffects,
  ) {
    let i = 0
    while (i < NUMBER_OF_CLASSES_PER_TERM) {
      const target = i + 1
      this.numOfClassesArray.push(target)
      i += 1
    }
  }

  ngOnInit() {
    this.enrolmentsSubscription = 
      this.store.select("enrolmentsReducer").subscribe((s: EnrolmentsStore) => {
        this.enrolment          = s.editableEnrolment
        this.selectedClass      = s.selectedClass
        this.selectedContact    = s.selectedContact
      })
    this.setSelectedItems()
  }

  setSelectedItems() {
    this.enrolment.numberOfClasses = this.numOfClassesArray.length // TODO: Get from backend
    this.startDateInputString = Utilities.getDateInInputStringFormat(new Date())
    this.transactionDateInputString = Utilities.getDateInInputStringFormat(new Date())
  }

  getMaxEnrolmentsForClass(matrixClass: MatrixClass) {
    return this.maxPerCampus[matrixClass.campus.code]
  }


  getStyleForSliderPoint(i: number) {
    return { 'left': `${100 / (this.numOfClassesArray.length - 1) * i}%` }
  }

  getStyleForSliderBarHighlight() {
    return { 'width': `${100 / (this.numOfClassesArray.length - 1) * (this.enrolment.numberOfClasses - 1)}%` }
  }

  clickedSliderPoint(i: number) {
    this.enrolment.numberOfClasses = this.numOfClassesArray.length - i
  }

  clickedSubmitForm(e: MouseEvent) {
    this.enrolment.startDate = new Date(this.startDateInputString)
    this.enrolment.transactionDate = new Date(this.transactionDateInputString)

    this.store.dispatch({ type: CREATE_ENROLMENT, payload: this.enrolment })

    this.enrolmentEffects.createEnrolment.take(1).subscribe((a: Action) => {
      if (a.type === ADD_ENROLMENT) {
        this.router.navigate(['contacts', this.selectedContact.id])
        this.modalService.closeModal()
      }
    })
  }

  ngOnDestroy() {
    this.enrolmentsSubscription.unsubscribe()
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/components/enrolment-form.ts